import * as React from 'react';
import {useState, useEffect} from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { TextField, Button, FormControl, makeStyles } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DoNotTouchOutlinedIcon from '@mui/icons-material/DoNotTouchOutlined';
import {GridRowModes, DataGrid, GridToolbarContainer, GridActionsCellItem, GridRowEditStopReasons, GridEditInputCell} from '@mui/x-data-grid';
import { createFakeServer } from '@mui/x-data-grid-generator';
import { useDispatch, useSelector } from "react-redux";

import RecipeService from '../../services/recipe.service';
import AuditTrailViewService from '../../services/audittrailview.service.js';
import ConfigurationViewService from '../../services/configurationview.service.js';
import DashboardAdd from './DashboardAdd.js';
import DashboardEdit from './DashboardEdit.js';
import MultipleWrite from './MultipleWrite.js';

import Snackbar from '@mui/material/Snackbar';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import { styled } from '@mui/material/styles';

import {Resizable, ResizableBox} from "re-resizable";

import Alert from '@mui/material/Alert';
import { Hidden } from '@mui/material';


// Add form open for tag addition in selected widget/dashboard.
function EditToolbar(props) {
  const { addTagIconStatus, setAddRecordForm, setMultiWriteForm, widgetDescription, configData, user} = props;
  //console.log(configData)
  //console.log(addTagIconStatus, configData[33].Color)
  const handleClick = () => {
    setAddRecordForm(true);
  };

  const handleMultipleWriteClick =() => {
    setMultiWriteForm(true);

  }

  const isTagAddAccess = user && user.UserAccess && user.UserAccess[15] && user.UserAccess[15].Enable === "Enabled" && user.UserAccess[15].Options 
  ? user.UserAccess[15].Options.includes(user.role)
  : false; // Default to false if user or the necessary properties are null or undefined

  return (
    <GridToolbarContainer
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: configData[32].Color,
    }}
    >
      {((isTagAddAccess || user.role === "engineer"  || user.role === "superadmin")) &&(
        <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
        
        </Button>
      )}

      <span 
        style={{ 
          marginLeft: 'auto',
          marginRight: 'auto',
          fontWeight: configData[35].FontWeight, // Make text bold
          fontSize: parseInt(configData[34].FontSize), // Set font size to 16
          color: configData[33].Color, // Set color to black

        }}>
          {widgetDescription}
        </span>

        <Button color="primary" startIcon={<DownloadIcon />} onClick={handleMultipleWriteClick}>
          Save to Device
        </Button>

      
      
    </GridToolbarContainer>
  );
}


//Function to merge two array data and keep arr2 data _id field ie redisdata
function mergeByTagName0(arr1, arr2) {
  // Use Map for fast lookup
  const map = new Map();

  // Add first array
  arr1.forEach(item => {
    map.set(item.TagName, { ...item });
  });

  // Merge second array
  arr2.forEach(item => {
    if (map.has(item.TagName)) {
      const existing = map.get(item.TagName);
      map.set(item.TagName, { ...existing, ...item });
    } else {
      map.set(item.TagName, { ...item });
    }
  });

  return Array.from(map.values());
}

// Keep _id of the arr1 ie recipeviewdata
function mergeByTagName(arr1, arr2) {
  const map = new Map();

  arr1.forEach(item => {
    map.set(item.TagName, { ...item });
  });

  arr2.forEach(item => {
    if (map.has(item.TagName)) {
      const existing = map.get(item.TagName);

      map.set(item.TagName, {
        ...existing,
        ...item,
        _id: existing._id, // Keep _id from recipeViewData
      });
    } else {
      map.set(item.TagName, { ...item });
    }
  });

  return Array.from(map.values());
}

// Function declared outside useEffect
function mergeAlarmWithProcessValues(alarmData = [], processData = []) {
  const valueMap = new Map();

  (processData || []).forEach(item => {
    if (item?.TagName) {
      valueMap.set(item.TagName, item.ProcessValue ?? null);
    }
  });

  return (alarmData || []).map(item => {
    if (!item || typeof item !== "object") return item;

    const updated = { ...item };
    const mappings = [
      ["TagNameHiHiSP", "HiHiSP"],
      ["TagNameHighSP", "HighSP"],
      ["TagNameLowSP", "LowSP"],
      ["TagNameLoLoSP", "LoLoSP"]
    ];

    mappings.forEach(([tagField, valueField]) => {
      const tag = item?.[tagField];
      if (tag && tag !== "NA") {
        updated[valueField] = valueMap.get(tag) ?? updated[valueField] ?? null;
      }
    });

    return updated;
  });
}

export default function Dasboard() {
  const { user } = useSelector((state) => state.auth);
  const projectName = user.selectedproject;
  const dashboardType = 'RecipeView';
  //const widgetName = useSelector((state) => state.splitbutton1.widgetName);
  const widgetName = useSelector((state) => state.splitbutton12WidgetName.widgetName);
  const widgetDescription = useSelector((state) => state.splitButton12WidgetDescription.widgetDescription);
  const recipeGroupName = useSelector((state) => state.splitbutton12GroupName.groupName);
  //console.log(recipeGroupName)
  //console.log(widgetDescription)
  const initWidgetConfigData = [{
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "1",
    "ParameterName": "Column1",
    "Enable": "Enabled",
    "Description": "Sr. no.",
    "Width": "100",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "2",
    "ParameterName": "Column2",
    "Enable": "Enabled",
    "Description": "Device Name",
    "Width": "170",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "3",
    "ParameterName": "Column3 ",
    "Enable": "Enabled",
    "Description": "Tag Name",
    "Width": "100",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "4",
    "ParameterName": "Column4",
    "Enable": "Enabled",
    "Description": "Tag Description",
    "Width": "170",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "5",
    "ParameterName": "Column5 ",
    "Enable": "Enabled",
    "Description": "Block Name",
    "Width": "170",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "6",
    "ParameterName": "Column6 ",
    "Enable": "Enabled",
    "Description": "Block ID",
    "Width": "100",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "7",
    "ParameterName": "Column7 ",
    "Enable": "Enabled",
    "Description": "Process Value",
    "Width": "170",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "8",
    "ParameterName": "Column8",
    "Enable": "Enabled",
    "Description": "Unit",
    "Width": "100",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "9",
    "ParameterName": "Column9",
    "Enable": "Enabled",
    "Description": "LoLo SP",
    "Width": "120",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
     "SrNo": "10",
    "ParameterName": "Column10",
    "Enable": "Enabled",
    "Description": "Low SP",
    "Width": "120",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "11",
    "ParameterName": "Column11",
    "Enable": "Enabled",
    "Description": "High SP",
    "Width": "120",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
     "SrNo": "12",
    "ParameterName": "Column12",
    "Enable": "Enabled",
    "Description": "HiHi SP",
    "Width": "120",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "13",
    "ParameterName": "Column13 ",
    "Enable": "Enabled",
    "Description": "Alarm Status",
    "Width": "170",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "14",
    "ParameterName": "Header Background Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "#A9BBD3",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "15",
    "ParameterName": "Header Font Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "black",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "16",
    "ParameterName": "Header Font Size",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "21",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "17",
    "ParameterName": "Header font Weight",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "bold",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "18",
    "ParameterName": "Header Text Align",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "19",
    "ParameterName": "Rows Background Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "white",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "20",
    "ParameterName": "Rows Font Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "black",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
     "SrNo": "21",
    "ParameterName": "Rows Font Size",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "14",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "22",
    "ParameterName": "Rows font Weight",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "normal",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "23",
    "ParameterName": "Rows Text Align",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "center",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "24",
    "ParameterName": "LoLo Alarm Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "#A2121D",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "25",
    "ParameterName": "Low Alarm Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "blue",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "26",
    "ParameterName": "High Alarm Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "purple",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "27",
    "ParameterName": "HiHi Alarm Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "red",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "28",
    "ParameterName": "No Alarm Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "black",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "29",
    "ParameterName": "Mouse Hover Background Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "skyblue",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na",
    "BorderStyle": "na",
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "30",
    "ParameterName": "Enable - Row Add",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "31",
    "ParameterName": "Enable - Row Edit",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "32",
    "ParameterName": "Enable - Row Delete",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "33",
    "ParameterName": "Recipe Title Background Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "white",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "34",
    "ParameterName": "Recipe Title Font Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "black",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "35",
    "ParameterName": "Recipe Title Font Size",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "20",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "36",
    "ParameterName": "Recipe Title font Weight",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "normal",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "37",
    "ParameterName": "Alarm LoLo Background Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "white",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "38",
    "ParameterName": "Alarm Low Background Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "white",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "39",
    "ParameterName": "Alarm High Background Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "white",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "40",
    "ParameterName": "Alarm HiHi Background Color",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "white",
    "FontWeight": "na",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "41",
    "ParameterName": "Alarm LoLo Font Size",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "18",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "42",
    "ParameterName": "Alarm Low Font Size",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "18",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "43",
    "ParameterName": "Alarm High Font Size",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "18",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "44",
    "ParameterName": "Alarm HiHi Font Size",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "na",
    "FontSize": "18",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "45",
    "ParameterName": "Alarm LoLo font Weight",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "bold",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "46",
    "ParameterName": "Alarm Low font Weight",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "bold",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "47",
    "ParameterName": "Alarm High font Weight",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "bold",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  },
  {
    "ProjectName": projectName ,
    "DashboardType": dashboardType,
    "WidgetName": widgetName,
    "SrNo": "48",
    "ParameterName": "Alarm hiHi font Weight",
    "Enable": "Enabled",
    "Description": "na",
    "Width": "0",
    "Color": "na",
    "FontWeight": "bold",
    "FontSize": "0",
    "TextAlignment": "na",
    "BorderStyle": "na"
  }];

  const [errorcodeConfigData, setErrorcodeConfigData] = React.useState({});

  const [fetchData, setFetchData] = useState(true);
  const[recipeViewData, setRecipeViewData] = useState([]);

  const[tagInfo, setTagInfo] = useState([]);
  const[alarmTagInfo, setAlarmTagInfo] = useState([]);

  const[modbustaglistData, setModbustaglistData] = useState([]);
  const[taglistLiveDataFetchDone, setTaglistLiveDataFetchDone] = useState(false);

  const[alarmconfigData, setAlarmconfigData] = useState([]);
  const[alarmTagListLiveDataFetchDone, setAlarmTagListLiveDataFetchDone] = useState(false);

  const[rowsData, setRowsData] = useState([]); // All rows data
  const[rowData, setRowData] = useState([]); // Selected row data
  const[rowsDataSetDone, setRowsDataSetDone] = useState(false);

  const[configData, setConfigData] = useState(initWidgetConfigData);
  const [addRecordForm, setAddRecordForm] = React.useState(false)
  const [multiWriteForm, setMultiWriteForm] = React.useState(false)
  
  const [editRecordForm, setEditRecordForm] = React.useState(false)
  const [editRowData, setEditRowData] = React.useState(false)

  const[deleteDialog, setDeleteDialog] = React.useState(false); // Delete Dialog bit
  const noButtonRef = React.useRef(null); 
  const [rowTagName, setRowTagName] = React.useState(); // Row Id refernace to delete the record
  const[deleteData, setDeleteData] = React.useState(false); //Delete row bit
  const [snackbar, setSnackbar] = React.useState(null); // if delete Success then set to success otherwise will set to fail
  const handleCloseSnackbar = () => setSnackbar(null);
  const [fetchingProgress, setFetchingProgress] = useState(0);
  const[addTagIconStatus, setAddTagIconStatus] = useState(true)

  const[remarkDialog, setRemarkDialog] = React.useState(false); // Remark Dialog bit
  const [eventDescription, setEventDescription] = useState("--");
  const [auditTrailRemark, setAuditTrailRemark] = useState("--");
  const [openRemarkBlnkMsg, setOpenRemarkBlnkMsg] = useState(false);
  const [password, setPassword] = useState('');
  const[pwdinterlock, setPwdInterlock] = useState("Disabled");
  
    
  // Progress bar
  const ProgressBar = ({ progress }) => {
    return (
      <div className="progress">
        <div className="progress-bar" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    );
  };

  // Get AuditTrail Configuration data for Remark field, either it is enabled or disabled
  useEffect(() =>{
    async function auditTrailConfigData()  {
    try {

      let dashboardName = 'AuditTrailConfig';
      let columnName = 'EventName';
      let columnValue = 'Remove Parameter From Recipe';
      let response = await AuditTrailViewService.getColumnData(dashboardName, columnName, columnValue);

      //console.log(response.data[0].EnableRemark);
      if(response.data.length > 0){
        setRowData({...rowData, EventStatus: response.data[0].EnableEvent, PWDInterlock: response.data[0].EnablePwdInterlock, RemarkStatus: response.data[0].EnableRemark});
        setPwdInterlock(response.data[0].EnablePwdInterlock);
        setEventDescription(response.data[0].DefaultEventDescription);
        // If remark field is disabled then set default remark vlaue to currrent Remark value
        if(response.data[0].EnableRemark === "Disabled"){
          setAuditTrailRemark(response.data[0].DefaultEventRemark);
        }
        
      }

    } catch (error) {
      console.log(error);

    }
  }

  auditTrailConfigData();

  }, []);

  //Get Application Configuration data 
  useEffect(() =>{
    async function getColumnData()  {
      try {

        let dashboardName = "ApplicationConfig";
        const response = await ConfigurationViewService.getAllRowsData(dashboardName);

        if(response.data.length > 0){
          //setPwdInterlock(response.data[10].TaskStatus);
          //console.log(response.data[10].TaskStatus); 

        }

        
        
      } catch (error) {
        console.log(error);

      }
    }
    getColumnData();



  }, []);

  
  // Get  All row data of ErrorCode configuration to replace error values with respective display values
  useEffect(() =>{
    async function getAllRowsData()  {
    try {

      let dashboardName = "ErrorCodeConfig"
      setErrorcodeConfigData([]);
      const response = await ConfigurationViewService.getAllRowsData(dashboardName);

      if (response){
        //console.log(response.data)
        //Keep only ErrorCode and RecipeView key values and delete rest
        const filteredData = response.data.map(({ErrorCode, RecipeView}) => ({ErrorCode, RecipeView}));
        //console.log(filteredData);
        setErrorcodeConfigData(filteredData);

      }
      
      
    } catch (error) {
      console.log(error);

    }
  }
  getAllRowsData();


  }, [widgetName]);

  //Get Recipeview data for selected widget
  useEffect(() =>{
    async function getColumnData()  {
    try {

      let dashboardName = "RecipeView";
      let columnName = "WidgetName";
      let columnValue = widgetName;
      
      const response = await RecipeService.getColumnData(dashboardName, columnName, columnValue );
      //console.log(response.data[16].FontWeight);
      if(response){
        //console.log(response.data);
        //console.log(response.data[0].TagName);
        setRecipeViewData(response.data);
        setFetchingProgress(100);

      }
      
      
    } catch (error) {
      console.log(error);

    }
  }
    getColumnData();

  
  }, [widgetName, fetchData]);

  
  // Get data of specific columns from TagList recipe for specific tagnames
   useEffect(() => {

        // Function to fetch Modbus TagList data from InMemory
        async function getModbusTagListData() {
            try {

            // If recipeViewData is empty, avoid API call and continue flow
            if (!recipeViewData || recipeViewData.length === 0) {
                setModbustaglistData([]);
                setTaglistLiveDataFetchDone(true);
                return;
            }

            // Extract TagName values from recipeViewData
            const keyName = "TagName";
            const valuesArray = recipeViewData.map(item => item[keyName]);
            //console.log(recipeViewData)

            // Prepare API parameters
            const dashboardName = "TagList";
            const columnsToRetrieve = ["TagType", "TagName", "RawValue", "ProcessValue", "TagQuality"];
            const columnToFilter = "TagName";
            const valueToMatch = valuesArray;

            // Fetch data from Inmemory
            const response = await RecipeService.getMultiFieldData(
                dashboardName,
                columnsToRetrieve,
                columnToFilter,
                valueToMatch
            );

            // Ensure response data is always an array
            const redisData = response && response.data ? response.data : [];
            //console.log(redisData)

            // Ensure tagInfo is always an array
            const tagInfoSafe = tagInfo ? tagInfo : [];

            //console.log(tagInfo)

            // Merge MongoDB data (tagInfo) with InMemory data
            const mergedData = mergeByTagName(recipeViewData, redisData);
            //console.log(redisData)


            // Process values based on TagCategory
            const updatedArray = mergedData.map(obj => {
                if (!obj) return obj;

                // Handle Digital tags
                if (obj.TagCatagory === "Digital" && obj.ProcessValue === "1") {
                return { ...obj, ProcessValue: obj.OnLabel };
                }

                if (obj.TagCatagory === "Digital" && obj.ProcessValue === "0") {
                return { ...obj, ProcessValue: obj.OffLabel };
                }

                // Handle Analog and String tags
                if (obj.TagCatagory === "Analog" || obj.TagCatagory === "String") {
                return { ...obj, ProcessValue: obj.ProcessValue };
                }

                // Default return
                return obj;
            });

    
            // Step 3: Handle communication error
            const updatedData = updatedArray.map(item => {
                if (item.TagQuality === 'bad') {
                return { ...item, PresentAlarmStatus: 'Comm. Error' };
                }
                return item;
            });

            // Step 4: Replace error codes
            const updatedProcessValueData = updatedData.map(obj => {
                const errorMatch = errorcodeConfigData.find(
                error => error.ErrorCode === obj.ProcessValue
                );

                return {
                ...obj,
                ProcessValue: errorMatch
                    ? errorMatch.RecipeView
                    : obj.ProcessValue
                };
            });

            // Final state update
            //console.log(updatedProcessValueData)
            setRowsData(updatedProcessValueData);



            } catch (error) {

            // Log error and prevent app from breaking
            console.log("ModbusTagList Error:", error);

            // Set empty data so UI does not get stuck
            setModbustaglistData([]);

            } finally {

            // Always move to next step in flow
            setTaglistLiveDataFetchDone(true);
            }
        }

        if (fetchData) {
            getModbusTagListData();
            setFetchData(false);
        }

    }, [fetchData]);

  // update rowsdata perodically after every 1 second
  useEffect(() => {
    const intervalId = setInterval(() => {
      if(fetchData === false){
        setFetchData(true); // make it true to start fetching recipeView-ModbusTaglist-alarmconfig data
        //console.log("fetchdata");
      }
      setFetchingProgress((prevProgress) => Math.min(prevProgress + 10, 100));


    }, 1500);

    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [fetchData]);
    
  // Delete  Specific Row row data 
  useEffect(() =>{
    async function deleteRowData()  {
    try {

      let dashboardName = "RecipeView"
      let auditTrailData =[{
        TimeStamp:new Date(),
        Activity: `Removed parameter '${rowData.TagName}' from recipe - '${widgetName}'`,
        ActivityType: "Remove Parameter From Recipe",
        UserName: user.email,
        Role: user.role,
        Remark: auditTrailRemark,
        EventStatus: rowData.EventStatus,
      }]

      const searchValue = rowData.TagName; // The value you're searching in recipeView collection to get record to retrive _id field from it.
   
      const foundObject = recipeViewData.find((item) => item.TagName === searchValue);

      //console.log(searchValue, foundObject)
      if (foundObject) {
        //console.log('Object found:', foundObject._id);
        let rowId = foundObject._id;
        //console.log(rowId, rowData._id)
        if (rowId === null){
          setSnackbar({ children: 'TagName value is null', severity: 'error' });
        }else{
          //let updatedRowData = {...rowData, _id: rowId, WidgetName: widgetName}
          let updatedRowData = {...rowData, _id: rowId, WidgetName: widgetName, email:user.email, role: user.role, PWDInterlock: pwdinterlock, PWD: password};
          //console.log(dashboardName, updatedRowData);
          const response = await RecipeService.deleteRow(dashboardName, updatedRowData, auditTrailData);  // update when id is present in data array
          if(response){
            setAuditTrailRemark("--"); // Clear remark field
            setSnackbar({ children: 'Tag Deleted successfully', severity: 'success' });
            setFetchData(true);
          
          }
        }

      } else {
        setSnackbar({ children: 'TagName is not present', severity: 'error' });
      }
    

    } catch (error) {
      setSnackbar({ children: "Tag deletion Failed", severity: 'error' });
      console.log(error);
      setAuditTrailRemark("--"); // Clear remark field

    }
  };
  if(deleteData){
    deleteRowData();
    setDeleteData(false);
  };


  }, [deleteData]);
    
  const handleClose = () => {
    setOpenRemarkBlnkMsg(false);
  };

  const handleRecordAdded = (data) => {
    
    setAddRecordForm(false);
    setFetchData(true);  // reload the data again from backend
    //console.log("Record Added", data);
    
  };

  const handleMultiWrite = (data) => {
    
    setMultiWriteForm(false);
    setFetchData(true);  // reload the data again from backend
    //console.log("Record Added", data);
    
  };

  

  const handleRecordEdited = (data) => {
    
    setEditRecordForm(false);
    setFetchData(true);  // reload the data again from backend
    
  };

  const handleDeleteYes = () => {
    setDeleteData(true);
    setDeleteDialog(false);
    setRemarkDialog(false);
  };

  const handleDeleteNo = () => {
    
    setDeleteDialog(false);
    setRemarkDialog(false);
    setAuditTrailRemark("--"); // Clear remark field
  };

  const renderDeleteConfirmDialog = () => {
    if (!deleteDialog) {
      return null;
    }

    //const { newRow, oldRow } = promiseArguments;
    //const mutation = computeMutation(newRow, oldRow);
    return (
      <div>

      <Dialog
        maxWidth="xs"
        //TransitionProps={{ onEntered: handleEntered }}
        open={!!deleteDialog}
      >
        <DialogTitle>Are you sure to delete selected Row?</DialogTitle>
        <DialogContent dividers>
          {`Pressing 'Yes' will delete the selected row.`}
        </DialogContent>
        
        {pwdinterlock === 'Enabled' && (<DialogContent dividers>
          <DialogContentText>
            Enter the Password to delete the selected record from recipe.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="Password"
            label="Password"
            type="password"
            fullWidth
            variant="standard"
            onChange={(event) => {
              setPassword(event.target.value);
            }}
          />

          </DialogContent>
        )}

        <DialogActions>
          <Button ref={noButtonRef} onClick={handleDeleteNo}>
            No
          </Button>
          <Button onClick={handleDeleteYes}>Yes</Button>
        </DialogActions>
      </Dialog>

      </div>
    );
  };

  const handleDelete = () => ()=> {   
    if(((rowData.RemarkStatus === "Enabled") && (auditTrailRemark === "--")) || ((rowData.RemarkStatus === "Enabled") && (auditTrailRemark === ""))){
      setOpenRemarkBlnkMsg(true);
      //console.log("Enter or change the Remark value to proceed further")
    }else{
      //console.log("test2");
      setDeleteDialog(true);
      setRemarkDialog(false);
      
    }
    
  };

  const handleRemarkChange = (event) => {
    const {name, value} = event.target;
    if(rowData.RemarkStatus === "Enabled"){
      setAuditTrailRemark(value);

    }
  };

  const renderRemarkDialog = () => {
    if (!remarkDialog) {
      return null;
    }

    //console.log("test1");
    //const { newRow, oldRow } = promiseArguments;
    //const mutation = computeMutation(newRow, oldRow);
    return (
      <div>

      <Dialog
        maxWidth="xs"
        //TransitionProps={{ onEntered: handleEntered }}
        open={!!remarkDialog}
      >
        <DialogTitle>Enter Remark</DialogTitle>
        {/*Remark */}
        <DialogContent 
        dividers
        >
          <Typography gutterBottom sx={{ mt: 0, mb:3, width: 350 }}>
          Enter remark or reason for delete action
          </Typography>

          <TextField
            id="outlined-multiline-static"
            label="Remark"
            name="Remark"
            placeholder="Enter Remark"
            multiline
            rows={2}
            style={{ width: 350 }}
            onChange={handleRemarkChange}
            //defaultValue="Default Value"
          />

        </DialogContent>


        <DialogActions>
          <Button ref={noButtonRef} onClick={handleDeleteNo}>
            Cancel
          </Button>
          <Button onClick={handleDelete()}>Delete</Button>
        </DialogActions>
      </Dialog>

      </div>
    );
  };

  const handleDeleteClick = (params) => () => {
    //setRowData({...params.row, email: user.email, role: user.role});
    //setRowTagName(tagName);
    //setDeleteDialog(true);
    //setRowData({...params.row, RemarkStatus: rowData.RemarkStatus, EventStatus:rowData.EventStatus, email:user.email, role: user.role, PWDInterlock: pwdinterlock, PWD: password});
    setRowData({...params.row, RemarkStatus: rowData.RemarkStatus, EventStatus:rowData.EventStatus});
    if(rowData.RemarkStatus === "Enabled"){
      //console.log("test0");
      setRemarkDialog(true);
    }else{
      //console.log("test0");
      const withoutRemark = handleDelete();
      withoutRemark();
    }
  };

  const isRecipeViewSPChangeAccess = user && user.UserAccess && user.UserAccess[14] && user.UserAccess[14].Options 
  ? user.UserAccess[14].Options.includes(user.role)
  : false;

  const checkTagEditable = (params) => {
    let editEnable = false;

    const found = recipeViewData.find(item => item.TagName === params.row.TagName);

    if (found) {
      editEnable = found.EditEnable === 'Enabled';
    }

    return editEnable;
  };

  const handleEditClick = (params) => () => {
    ///Check edit permission 
    setEditRowData(params);
      if (user.role !== "visitor"){
        if(isRecipeViewSPChangeAccess){
          setEditRecordForm(true);
        }
        if(user.role === "engineer" || user.role === "superadmin"){
          setEditRecordForm(true);
        }
      }

  }

  const handleRowDoubleClick = (params, event) => {
    //Check edit permission 
    const isEditable = checkTagEditable(params); 
    if(isEditable){

      if(configData[30].Enable === "Enabled"){
        setEditRowData(params);
        if (user.role !== "visitor"){
          if(isRecipeViewSPChangeAccess){
            setEditRecordForm(true);
          }
          if(user.role === "engineer" || user.role === "superadmin"){
            setEditRecordForm(true);
          }
        } 
        
      }
    }
    
  };


  const shouldHideColumn = (configData[30].Enable === "Disabled") && (configData[31].Enable === "Disabled");
  //console.log(shouldHideColumn)

  const columns = [
    //{ field: 'SrNo', headerName: "Sr. No.", width: 80, headerAlign: "center", align: "center", headerClassName: 'theme--header', },
    { field: 'ParameterName', headerName: "Parameter Name", width: 300, headerAlign: "center", align: "center", headerClassName: 'theme--header',},
    { field: 'ParameterUnit', headerName: "Unit", width: 150, headerAlign: "center", align: "center", headerClassName: 'theme--header', },
    { field: 'RecipeValue', headerName: "Recipe Value", width: 150, headerAlign: "center", align: "center", headerClassName: 'theme--header', },
    {
      field: 'ProcessValue',
      headerName: "Actual Value",
      width: configData[6].Width,
      headerAlign: configData[6].TextAlignment,
      align: configData[6].TextAlignment,
      headerClassName: 'theme--header',

      renderCell: (params) => {
        const row = params.row;

        const isOn =
          row.TagCatagory === "Digital" &&
          row.ProcessValue === row.OnLabel;

        const isOff =
          row.TagCatagory === "Digital" &&
          row.ProcessValue === row.OffLabel;

        const isstring =
          row.TagCatagory === "String";

        const style = isOn
          ? {
              color: row.OnLabelColor,
              backgroundColor: row.OnBackgroundColor,
            }
          : isOff
          ? {
              color: row.OffLabelColor,
              backgroundColor: row.OffBackgroundColor,
            }
          : isstring
          ?{
            color: row.OnLabelColor,
            backgroundColor: row.OnBackgroundColor,
          }
          :{};

        const alignMap = {
          left: 'flex-start',
          center: 'center',
          right: 'flex-end',
        };
        //console.log(row.FontSize, typeof row.FontSize);
        return (
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: alignMap[params.colDef.align] || 'flex-start',
              //fontWeight: row.FontWeight || 'normal',
              //fontSize: Number(row.FontSize) || 16,
              fontSize: configData[20]?.FontSize ? parseInt(configData[20].FontSize, 10) : 14,
              fontWeight: configData[21]?.FontWeight || 'normal',
              lineHeight: 1.2,
              //border: '1px solid #d4d4d4',
              ...style,
            }}
          >
            {params.value}
          </div>
        );
      }
    },
    (user.role !== "visitor") &&      
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      headerClassName: 'theme--header',
      width: 0,
      hideable: true,
      hide: false,
      cellClassName: 'actions',
      getActions: (params) => {
        const tagName = params.row.TagName;
        const actions = [];
        actions.push(
          <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          className="textPrimary"
          onClick={handleEditClick(params)}
          color="inherit"
        />
        );
        actions.push(
            <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(params)}
            color="inherit"
            />
        );

        return actions;

        
      },
      
    },

  ];
  

  return (
    <div >

      {renderDeleteConfirmDialog()}
      {renderRemarkDialog()}
      <Paper
       style={{ maxWidth: 'fit-content', flex: 1, padding: '6px' }}
        sx={{
          //height: 400,
          width: '100%',
          margin: 'auto',
          position:"relative",
          overflow: 'hidden ! important',
          '&.MuiDataGrid-main':{overflowX:'hidden ! important', overflowY:'hidden ! important'},
          '& .theme--header':{backgroundColor: configData[13].Color, color: configData[14].Color, 
            fontSize: parseInt(configData[15].FontSize), fontWeight: configData[16].FontWeight, 
            border: configData[17].BorderStyle, whiteSpace: 'normal', wordWrap: 'break-word',},
          '& .theme--row': { 
            backgroundColor: configData[18].Color,
            color: configData[19].Color,
            fontSize:parseInt(configData[20].FontSize),
            fontWeight: configData[21].FontWeight,
            //border: configData[22].BorderStyle,
            //border: '1px solid #d4d4d4',
            //borderRight: 1,
            overflowWrap: 'break-word',
          },
          '& .theme--verborder': {
            border: configData[17].BorderStyle,
          },
        }}
        elevation={24}
      >
         {/* <Box display="flex" alignItems="center" justifyContent="center" border={0} p={0} sx={{'&.MuiDataGrid-main':{overflowX:'hidden ! important', overflowY:'hidden ! important'}}}> */}
         <Box >
        {fetchingProgress < 100 ? (
          <div style={{ height: 50, width: '100%', overflowX: 'hidden', overflowY: 'hidden' }}>
          <p>Data fetching in progress...</p>
          <ProgressBar progress={fetchingProgress} />
        </div>
        ):(
          <div style={{ height: '100%', width: '100%', overflowX: 'hidden', overflowY: 'hidden' }} >
            <DataGrid
            rows={rowsData}
            getRowId={(rowsData) => rowsData._id} // This line will set id of the datagrid row = _id of the mongodb database, otherwisw error can occured.
            columns={columns} // enable/disable individual column as per setting
            disableRowSelectionOnClick  // disable row selection
            onRowDoubleClick={handleRowDoubleClick} // Double click event handler
            //hideFooterPagination = {true}
            //hideFooter

            getHeaderClassName={(params) =>{return 'theme--header';}}
            getRowClassName={(params) => {return 'theme--row';}}
            //{...data}
            sx={{
              //width:'1678px',
              "& .MuiDataGrid-row:hover": {
                backgroundColor: configData[28].Color
                // on hover, background color of thr row
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: 1.2
                // wrap the column header text
              },
              "& .MuiDataGrid-cell": {
                whiteSpace: 'normal !important', /* Important to override other styles */
                lineHeight: 1.2,
                wordWrap: 'break-word',
                // wrap the  cell text
              },
            }}

            slots={{
              toolbar: EditToolbar,
            }}
            slotProps={{
              toolbar: { addTagIconStatus, setAddRecordForm, setMultiWriteForm, widgetDescription, configData, user},
            }}
          />
          </div>
          
        )}
          
        </Box>

        {(addRecordForm && user.role !== "visitor") && (
        <DashboardAdd open= {addRecordForm} close = {handleRecordAdded} />
        )}

        {editRecordForm && (
        <DashboardEdit params = {editRowData} open= {editRecordForm} close = {handleRecordEdited} />
        )}

        {(multiWriteForm && user.role !== "visitor") && (
        <MultipleWrite recipeGroupName= {recipeGroupName} recipeName = {widgetName} params = {rowsData} open= {multiWriteForm} close = {handleMultiWrite} />
        )}

        {!!snackbar && (
          <Snackbar anchorOrigin={{ vertical:"top", horizontal:"center" }}  open onClose={handleCloseSnackbar} autoHideDuration={4000}>
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}

        {/* Open Remark Field is blank dialog box */}
        <Dialog open={openRemarkBlnkMsg} onClose={handleClose}>
          <DialogTitle>Enter Remark Field</DialogTitle>
          <Box sx={{width: 450 }}>
          <DialogContent dividers>
            <DialogContentText>
                Enter or change the Remark Field to proceed further.
                <br />
                (Note: '--' Value for remark field is not acceptable)
            </DialogContentText>
            
          </DialogContent>
          </Box>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
          </DialogActions>
        </Dialog>

      </Paper>
    </div>
  );
}